import {createSlice} from "@reduxjs/toolkit";

export const productSlice = createSlice({
    name: 'product',
    initialState: {
        selectedProducts: [],
        allProducts: [],
        activeTab: 1,
        paginations: null,
        sendRequest: false,
        requestStatus: true,
        initialParams: {
            page: 1,
            search: '',
            search_columns: {
                name: 0,
                description: 0,
                style_no: 0
            },
            name: 1,
            description: 1,
            style_no: 1,
            sort: 'created_at',
            sort_order: 'desc',
            status: 1,
            vendor_id: '',
            parent_category_id: '',
            second_category_id: '',
            third_category_id: '',
            per_page: 50
        },
        currentEditProduct: null,
    },
    reducers: {
        selectUnselectProduct: (state, action) => {
            const id = action.payload;
            const existingItemIndex = state.selectedProducts.findIndex(item => item === +id);

            if (existingItemIndex !== -1) {
                state.selectedProducts = state.selectedProducts.filter(item => item !== +id);
            } else {
                state.selectedProducts.push(+id);
            }
        },
        setSelectToggle: (state, action) => {
            if(action.payload.type === 'select'){
                state.selectedProducts = []
                state.allProducts.map((item) => state.selectedProducts.push(item.id))
            }

            if(action.payload.type === 'unselect'){
                state.selectedProducts = []
            }
        },
        setTabStatus: (state, action) => {
            state.activeTab = action.payload === 'active_item' ? 1 : 0
        },
        setParams: (state, action) => {
            state.initialParams = action.payload
        },
        setProductPagination: (state, action) => {
            state.paginations = action.payload
        },
        setAllProducts: (state, action) => {
            state.allProducts = action.payload
        },
        setSendRequest: (state, action) => {
            state.sendRequest = action.payload
        },
        setRequestStatus: (state, action) => {
            state.requestStatus = action.payload
        },
        setCurrentEditProduct: (state, action) => {
            state.currentEditProduct = action.payload
        },
    }

});
export const {
    selectUnselectProduct,
    setTabStatus,
    setAllProducts,
    setProductPagination,
    setRequestStatus,
    setParams,
    setSendRequest,
    setCurrentEditProduct,
    setSelectToggle
} = productSlice.actions;
export default productSlice.reducer;
